import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { SectionHeading } from "../common/SectionHeading";
import { bpoRoles, bpoCategories, images } from "../../data/content";
import { Headset } from "@phosphor-icons/react";

export const BpoSection = () => {
    const [cat, setCat] = useState("All");
    const filtered = cat === "All" ? bpoRoles : bpoRoles.filter((r) => r.cat === cat);

    return (
        <section className="relative bg-navy-deep grain overflow-hidden" data-testid="bpo-section">
            <div className="absolute top-0 right-0 w-1/3 h-full opacity-20 hidden lg:block">
                <img src={images.bpo} alt="BPO workforce" className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-r from-navy-deep to-transparent" />
            </div>
            <div className="relative z-10 mx-auto max-w-[1400px] px-5 lg:px-10 py-24 lg:py-32">
                <div className="flex items-center gap-3 mb-4">
                    <Headset size={26} weight="duotone" className="text-brand" />
                    <span className="text-xs uppercase tracking-[0.25em] font-semibold text-brand">Premium Vertical</span>
                </div>
                <SectionHeading
                    dark
                    title="BPO & BPM Workforce Solutions"
                    subtitle="A dedicated vertical delivering trained voice, non-voice, sales, operations, quality and support workforce for BPO/BPM organizations across India."
                />

                <div className="mt-10 flex flex-wrap gap-2" data-testid="bpo-filters">
                    {bpoCategories.map((c) => (
                        <button
                            key={c}
                            onClick={() => setCat(c)}
                            data-testid={`bpo-filter-${c.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                            className={`px-4 py-2 rounded-sm text-xs font-semibold uppercase tracking-wider transition-colors duration-200 ${
                                cat === c ? "bg-brand text-white" : "bg-white/5 text-slate-300 border border-white/10 hover:bg-white/10"
                            }`}
                        >
                            {c}
                        </button>
                    ))}
                </div>

                <motion.div layout className="mt-8 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
                    <AnimatePresence mode="popLayout">
                        {filtered.map((r) => (
                            <motion.div
                                key={r.role}
                                layout
                                initial={{ opacity: 0, scale: 0.95 }}
                                animate={{ opacity: 1, scale: 1 }}
                                exit={{ opacity: 0, scale: 0.95 }}
                                transition={{ duration: 0.25 }}
                                className="p-4 rounded-sm bg-white/5 border border-white/10 hover:border-brand transition-colors"
                            >
                                <div className="text-sm font-medium text-white leading-tight">{r.role}</div>
                                <div className="mt-1.5 text-[10px] uppercase tracking-wider text-brand">{r.cat}</div>
                            </motion.div>
                        ))}
                    </AnimatePresence>
                </motion.div>
                <p className="mt-6 text-xs text-slate-400">Showing {filtered.length} roles{cat !== "All" ? ` in ${cat}` : ""}.</p>
            </div>
        </section>
    );
};
